import { FC, useEffect, useRef } from 'react';
import { ErrorContainer } from './styled';
import { datadogLogs } from '@datadog/browser-logs';

interface Props {
  children: React.ReactNode;
  data: {
    component: string;
    [key: string]: any;
  };
  errorMsg?: string;
  shouldAlert?: boolean;
}

export const ErrorComponent: FC<Props> = ({ children, data, shouldAlert, errorMsg = '' }) => {
  const hasLogged = useRef(false);

  useEffect(() => {
    if (!shouldAlert || hasLogged.current) return;
    hasLogged.current = true;
    datadogLogs.logger.warn(`Browser error occurred: ${errorMsg}`, data, new Error(errorMsg));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldAlert]);

  return <ErrorContainer>{children}</ErrorContainer>;
};

export default ErrorComponent;
